import React from 'react';
import { useFeatureValue } from '@growthbook/growthbook-react';
import classNames from 'classnames';
import styles from './SaleBadge.module.scss';
import { ReactComponent as Logo } from '../../assets/images/fi-logo.svg';
import { useTranslation } from 'react-i18next';

export interface SaleBadgeProps {
  className?: string;
  freeTrialEnabled?: boolean;
}

export function SaleBadge({ className, freeTrialEnabled }: SaleBadgeProps) {
  const saleBadge = useFeatureValue('ecom-bfcm-badge', 0);
  const { t } = useTranslation();

  // free trial badge takes precedence when enabled
  if (freeTrialEnabled) {
    return <div className={classNames(styles.saleBadge, styles.freeTrialBadge, className)}>{t('free_trial')}</div>;
  }

  if (saleBadge === 0) {
    return null;
  }

  const isFriday = saleBadge === 1;

  return (
    <div className={classNames(styles.saleBadge, className)}>
      {isFriday ? (
        <>
          {t('black')} <Logo className={styles.blackFridayLogo} /> {t('day_lowercase')}
        </>
      ) : (
        <>
          <Logo className={styles.cyberMondayLogo} />
          {t('cyber_monday')}
        </>
      )}
    </div>
  );
}
